module.exports = __webpack_public_path__ + "img/zhujiefuwu_image_ylfw_zlfw.d8d676b1.png";